import React, { memo, MutableRefObject, useEffect, useRef } from 'react';
import { GridHelper } from 'three';
import { EUnitType } from '../../@types/Enums';
import { useUnitContext } from '../../provider/UnitProvider';

import {
    GRID_COLOR_BLACK,
    GRID_COLOR_GREY,
    GRID_MODULO_DIVISOR,
    SINGLE_CANVAS_SIDE_SIZE
} from '../../utils/constants';

const FloorPlannerGrid = memo(() => {
    const { unitType } = useUnitContext();
    const gridHelperRef = useRef<GridHelper>();
    
    const black = [GRID_COLOR_BLACK, GRID_COLOR_BLACK, GRID_COLOR_BLACK];
    const grey = [GRID_COLOR_GREY, GRID_COLOR_GREY, GRID_COLOR_GREY];

    // metric uses standard 40 (10 splits). IMPERIAL needs 16 bc we want 4 squares per foot
    const currentModulo = unitType === EUnitType.METRIC ? GRID_MODULO_DIVISOR : 16;

    // SCALING: 10cm / 3inches is roughly 1.3123. 
    // makes the grid tighter for imperial to represent 3 inch tiles
    const divisions = unitType === EUnitType.METRIC 
        ? SINGLE_CANVAS_SIDE_SIZE 
        : Math.round(SINGLE_CANVAS_SIDE_SIZE * 1.3123);

    useEffect(() => {
        const gridHelper = gridHelperRef.current!
        const colorAttribute = gridHelper.geometry.attributes.color
        const positionAttribute = gridHelper.geometry.attributes.position

        for (let i = 0; i < positionAttribute.count; i++) {
            // standard grid logic but with dynamic modulo
            if (i % currentModulo === 0 || i % currentModulo === 2) {
                colorAttribute.setXYZ(i, black[0], black[1], black[2])
            } else {
                colorAttribute.setXYZ(i, grey[0], grey[1], grey[2])
            }
        }

        colorAttribute.needsUpdate = true
    }, [unitType, currentModulo, black, grey]) 

    return (
        <group name={`group-gridHelper`}>
            <gridHelper
                // KEY forces threejs to rebuild geometry on unit change
                key={unitType} 
                name={"gridHelper"}
                ref={gridHelperRef as MutableRefObject<GridHelper>}
                args={[SINGLE_CANVAS_SIDE_SIZE, divisions]}
                rotation={[Math.PI / 2, 0, 0]}
            />
        </group>
    )
})

export default FloorPlannerGrid